module.exports = __webpack_public_path__ + "static/media/steve-crater-lake.75978620.jpg";